import { render, staticRenderFns } from "./zhike.vue?vue&type=template&id=071d7ae6&scoped=true&"
import script from "./zhike.vue?vue&type=script&lang=ts&"
export * from "./zhike.vue?vue&type=script&lang=ts&"
import style0 from "./zhike.vue?vue&type=style&index=0&id=071d7ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071d7ae6",
  null
  
)

export default component.exports